import RoomCard from './RoomCard.jsx'

/**
 * Shown to a logged-in instructor before they've claimed a room.
 * Displays both rooms side-by-side with their state. Handles claim/take-over
 * and the "no rooms available" edge case.
 *
 * Claims are manual-only — Release button is the only way to release. If a
 * phone screen-locks, the room stays claimed; take-over is the escape valve
 * for stuck rooms.
 */
export default function RoomPicker({ rooms, myUserId, onClaimRoom }) {
  const main = rooms.main || {}
  const late = rooms.late || {}

  // "No rooms available" when both rooms are claimed by SOMEONE OTHER than
  // this instructor. They can still take over either one if needed.
  const mainTakenByOther = main.active_instructor && main.active_instructor !== myUserId
  const lateTakenByOther = late.active_instructor && late.active_instructor !== myUserId
  const bothTakenByOthers = mainTakenByOther && lateTakenByOther

  function handleClaim(roomId) {
    onClaimRoom(roomId, /* takeOver */ false)
  }
  function handleTakeOver(roomId) {
    const room = rooms[roomId] || {}
    const displayName = room.active_instructor_name || 'the current instructor'
    if (!confirm(
      `This will release ${displayName} from ${roomId === 'main' ? 'Main Room' : 'Room 2'}. ` +
      `Use this only if they've finished their set or stepped away (e.g., their phone died). Continue?`
    )) return
    onClaimRoom(roomId, /* takeOver */ true)
  }

  return (
    <div className="space-y-4">
      <div>
        <h2 className="font-semibold mb-1">Choose your room</h2>
        <p className="text-xs text-peak-muted">
          Each room runs independently. Claim one to start tracking now-playing and
          accept dance requests for that room. Use Release when you're done — claims
          don't time out automatically.
        </p>
      </div>

      {bothTakenByOthers && (
        <div className="card border-peak-warn/40 bg-peak-warn/5">
          <p className="font-semibold text-peak-warn">No rooms available</p>
          <p className="text-xs text-peak-muted mt-1">
            Both rooms are currently being run by other instructors. Wait for one to release,
            or use "Take over" if you've coordinated a hand-off.
          </p>
        </div>
      )}

      <div className="grid sm:grid-cols-2 gap-3">
        <RoomCard
          roomId="main"
          roomConfig={main}
          myUserId={myUserId}
          onClaim={() => handleClaim('main')}
          onTakeOver={() => handleTakeOver('main')}
        />
        <RoomCard
          roomId="late"
          roomConfig={late}
          myUserId={myUserId}
          onClaim={() => handleClaim('late')}
          onTakeOver={() => handleTakeOver('late')}
          practiceLabel={late.line_dancing_active ? 'Line Dancing Only' : 'Practice mode'}
        />
      </div>
    </div>
  )
}
